export enum SectorEnum {
  ACCOUNTING = "ACCOUNTING",
  FINANCE = "FINANCE",
  HR = "HR",
  BOARD = "BOARD",
  AUDIT = "AUDIT",
  OPERATIONS = "OPERATIONS",
  PURCHASING = "PURCHASING",
  LOGISTICS = "LOGISTICS",
}

export const SECTOR_LABELS: Record<SectorEnum, string> = {
  [SectorEnum.ACCOUNTING]: "Contábil",
  [SectorEnum.FINANCE]: "Financeiro",
  [SectorEnum.HR]: "RH",
  [SectorEnum.BOARD]: "Diretoria",
  [SectorEnum.AUDIT]: "Auditoria",
  [SectorEnum.OPERATIONS]: "Operações",
  [SectorEnum.PURCHASING]: "Compras",
  [SectorEnum.LOGISTICS]: "Logística",
};

export const SECTORS: readonly SectorEnum[] = Object.values(SectorEnum);

export enum ShippingTypeEnum {
  LOSS_SPREADSHEET = "LOSS_SPREADSHEET",
  RANKINGS_SPREADSHEET = "RANKINGS_SPREADSHEET",
  HR_EMAIL = "HR_EMAIL",
}

const AUTOMATIC_DISPATCH_MICROCOPY: string =
  "gera último dia 23h / envia dia 1 do mês seguinte 08h";

export const SHIPPING_TYPES: readonly {
  value: ShippingTypeEnum;
  label: string;
  microcopy: string;
  badgeClassName: string;
}[] = [
  {
    value: ShippingTypeEnum.LOSS_SPREADSHEET,
    label: "Planilha Perdas",
    microcopy: AUTOMATIC_DISPATCH_MICROCOPY,
    badgeClassName: "bg-purple-50 text-purple-700 border-purple-200",
  },
  {
    value: ShippingTypeEnum.RANKINGS_SPREADSHEET,
    label: "Planilha Rankings",
    microcopy: AUTOMATIC_DISPATCH_MICROCOPY,
    badgeClassName: "bg-amber-50 text-amber-700 border-amber-200",
  },
  {
    value: ShippingTypeEnum.HR_EMAIL,
    label: "Email para RH",
    microcopy: "sob demanda (aprovação de vales)",
    badgeClassName: "bg-teal-50 text-teal-700 border-teal-200",
  },
] as const;

export const SHIPPING_TYPE_VALUES: readonly ShippingTypeEnum[] =
  SHIPPING_TYPES.map((type) => type.value);

export const CORPORATE_EMAIL_DOMAIN: string = "@grupoavenida.com.br";

export const CORPORATE_EMAIL_REGEX: RegExp =
  /^[^\s@]+@grupoavenida\.com\.br$/i;

export { DEFAULT_PER_PAGE, PER_PAGE_OPTIONS } from "@/constants/pagination";

export type RecipientSortColumn =
  | "sector"
  | "name"
  | "email"
  | "status"
  | "created_at";

export type SortDirection = "asc" | "desc";

export const RECIPIENT_SORT_BY_COLUMN_ID: Readonly<
  Record<string, RecipientSortColumn>
> = {
  active: "status",
  sector: "sector",
  recipient: "name",
};

export const DEFAULT_SORT_DIRECTION: SortDirection = "asc";

export const DEFAULT_RECIPIENT_SORT: RecipientSortColumn = "name";

export const SORT_DIRECTIONS: readonly SortDirection[] = ["asc", "desc"];

export const RECIPIENT_SORT_COLUMNS: readonly RecipientSortColumn[] =
  Object.values(RECIPIENT_SORT_BY_COLUMN_ID);

export { DEFAULT_PAGE } from "@/constants/pagination";

export const SECTOR_EMAILS_PARAMS = {
  SEARCH: "search",
  ACTIVE: "active",
  SECTORS: "sectors",
  SHIPPING_TYPES: "shipping_types",
  PAGE: "page",
  PER_PAGE: "perPage",
  SORT: "sort",
  DIRECTION: "direction",
} as const;

export const ACTIVE_VALUES: readonly boolean[] = [true, false];

export const ACTIVE_PARAM_BY_VALUE: Readonly<Record<string, boolean>> = {
  true: true,
  false: false,
};

export const COLUMN_ID_BY_RECIPIENT_SORT: Readonly<
  Partial<Record<RecipientSortColumn, string>>
> = Object.fromEntries(
  Object.entries(RECIPIENT_SORT_BY_COLUMN_ID).map(
    ([columnId, sort]: [string, RecipientSortColumn]): [
      RecipientSortColumn,
      string,
    ] => [sort, columnId]
  )
);

export const ACTIVE_STATUS_OPTIONS: readonly {
  value: boolean;
  label: string;
}[] = [
  { value: true, label: "Ativo" },
  { value: false, label: "Inativo" },
];

export const COLUMN_TITLES = {
  ACTIVE: "Ativo",
  SECTOR: "Setor",
  RECIPIENT: "Destinatário / E-mail",
  SHIPPING_TYPES: "Tipo(s) de Envio",
  ACTIONS: "Ações",
} as const;

export const JOB_POLL_INTERVAL_MS = 1500;

export const SETTLED_JOB_STATES: readonly string[] = ["completed", "failed"];
